import { useEffect } from 'react';
import { useRouter } from 'next/router';
import { trackPageView } from 'base/utils/tracker';
import { getFeaturesConfig } from '@pro/brand/service';

export function useBrandPage(){
    const { query } = useRouter();

    useEffect(() => {
        trackPageView();

        if (query.mock === '1') {
            getFeaturesConfig(true, query.theme);
        }
    }, []);
}
